
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { CheckboxComponent, LoaderModule, SearchBarComponent } from '@mds/ui';
import { FormsModule } from '@angular/forms';
import { MenuService } from '@services/menu.service';

@Component({
  selector: 'app-list-search-checkbox',
  standalone: true,
  templateUrl: './list-search-checkbox.component.html',
  styleUrls: ['./list-search-checkbox.component.scss'],
  imports: [FormsModule, MatDialogModule, CheckboxComponent, SearchBarComponent, LoaderModule]
})
export class ListSearchCheckboxComponent implements OnChanges {
  @Input() list: any[] = [];
  @Input() selectedList: any[] = [];
  @Output() refreshFavorite = new EventEmitter<any>();

  filteredListData: any[] = [];
  loader = false;
  loaderIndex = -1;

  constructor(private menuService: MenuService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.list || changes.selectedList) {
      this.updateFilteredList(this.list);
    }
  }

  onClickCheckbox(item: any, index: number): void {
    const rid = [item.rid?.replace('#', '')];
    item.checked = !item.checked;
    this.loaderIndex = index;
    this.loader = true;

    const apiCall = item.checked
      ? this.menuService.addFavoriteApi({ apps: { rids: rid } })
      : this.menuService.removeFavorite(rid);

    apiCall.subscribe(() => {
      this.refreshFavorite.emit(item.rid);
      this.loader = false;
    });
  }

  onSearch(query: string): void {
    const lowerQuery = query.toLowerCase() || '';
    const filtered = this.list.filter((p) => p.app_name?.toLowerCase().includes(lowerQuery));
    this.updateFilteredList(filtered);
  }

  private updateFilteredList(sourceList: any[]): void {
    const selectedIds = new Set(this.selectedList?.map((i) => i.rid.replace('#', '')));

    if (sourceList) {
      this.filteredListData = sourceList
        .map((item) => ({
          ...item,
          checked: selectedIds.has(item.rid.replace('#', ''))
        }))
        .sort((a, b) => Number(b.checked) - Number(a.checked));
    }
  }

  trackByIndex = (index: number): number => {
    return index;
  };
}
